import CustomerAgentListDto from "../customeragentmodule/CustomerAgentListDto";
import DataSourceAuthenticationDto from "./DataSourceAuthenticationDto";
import DataSourceTypeListDto from "./DataSourceTypeListDto";

export default class DataSourceFormDto {

    constructor(dataSourceType: DataSourceTypeListDto | null, dataSourceName: string | null, customerAgent: CustomerAgentListDto | null, dataSourceAuthentication: DataSourceAuthenticationDto | null) {
        this.DataSourceType = dataSourceType;
        this.DataSourceName = dataSourceName;
        this.CustomerAgent = customerAgent;
        this.DataSourceAuthentication = dataSourceAuthentication;
    }

    DataSourceType: DataSourceTypeListDto | null;
    DataSourceName: string | null;
    CustomerAgent: CustomerAgentListDto | null;
    DataSourceAuthentication: DataSourceAuthenticationDto | null;
}